import React from "react";
import { Container } from "@material-ui/core";
import Masonry from "react-masonry-css";
import { useStyles } from "./style";
import Post from "../../components/post/masonry";

const itemsStyle = [
  {
    img: {
      height: 847.5,
    },
    title: {
      fontSize: 52,
    },
  },
  {
    img: {
      height: 565,
    },
    title: {
      fontSize: 30,
    },
  },
  {
    img: {
      height: 282.5,
    },
    title: {
      fontSize: 30,
    },
  },
  {
    img: {
      height: 565,
    },
    title: {
      fontSize: 30,
    },
  },
];

const breakpointColumnsObj = {
  default: 2,
  768: 1,
};

export default function MasonrySection({ data }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="vgl-masonry-grid"
          columnClassName="vgl-masonry-grid_column"
        >
          <Post itemStyle={itemsStyle[0]} post={data[0].node} />
          <Post itemStyle={itemsStyle[1]} pdTop={100} post={data[1].node}/>
          <Post itemStyle={itemsStyle[2]} post={data[2].node}/>
          <Post itemStyle={itemsStyle[3]} post={data[3].node}/>
        </Masonry>
      </Container>
    </div>
  );
}
